<template>
  <div
    :id="`inner-chat-items-${mode}`"
    class="inner-chat-items"
    :class="[sort, mode]">
    <div
      v-if="parrentId"
      class="s-modal-mask"
      style="z-index: 1002;"/>
    <EmptyTab
      v-if="!value.messages || !value.messages.length"/>
    <template
      v-else>
      <InnerChatCard
        v-for="(item, itemIndex) in value.messages"
        :key="`inner-chat-item-${itemIndex}`"
        :data-qa="`inner-chat-item-${itemIndex}`"
        :index="itemIndex"
        :item="item"
        :mode="mode"
        @answer="val => $emit('answer',val)"
        @changeViewed="val => eventChangeViewedMessages(val)"
        @scrollToParrent="scrollToParrent"/>
      <div
        v-if="value.messages.length < value.messagesCount"
        class="block-load-message"
        :class="mode">
        <sIcon
          class="my-auto mr-2"
          color="var(--color-main-green)"
          size="24"
          spin
          type="loading"/>
        <div
          class="my-auto">
          {{ $t('Common.LoadingMessage') }}
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import InnerChatCard from 'components/common/blocks/inner-chat/InnerChatCard.vue'
import EmptyTab from 'components/common/elements/EmptyTab.vue'
import { debounce } from 'toolkit/utils/util'
import { doomMixin, innerChatMixin } from 'mixins'

/**
 * Вопросы участников в панели истории
 */
export default {
  name: 'innerChatCards',
  mixins: [doomMixin, innerChatMixin],
  data() {
    return {
      element: null,
      parrentId: null,
    }
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    mode: {
      type: String,
      default: 'small'
    },
    sort: {
      type: String,
      default: 'acs',
      validator: function (value) {
        return ['acs', 'desc'].indexOf(value) !== -1
      },
    }
  },
  computed: {
    filtredList() {
      return this.$_.filter(this.value.messages, el => el )
    },
  },
  methods: {
    async loadToParrentMessage() {
      if (this.value.messages.find(i => i.id === this.parrentId)) {
        this.$root.$off('loadInnerChatFinish', this.loadToParrentMessage)
        this.scrollToParrent(this.parrentId)
        this.parrentId = null
      } else {
        this.$emit('loadPage')
      }
    },
    eventChangeViewedMessages(val) {
      this.$emit('changeViewedMessages', [{
        messageId: val.id,
        eventType: 'InnerChat'
      }])
    },
    scrollToParrent(parrentId) {
      var myElement = document.getElementById(`inner-chat-${parrentId}-${this.mode}`)
      if (myElement) {
        if (myElement.classList.contains('blink')) {
          myElement.classList.remove('blink')
        }
        myElement.classList.add('blink')
        var topPos = myElement.offsetTop
        const cards = document.getElementById(`inner-chat-items-${this.mode}`)
        this.$_scrollTo(cards, topPos - 50, 600)
      } else {
        this.parrentId = parrentId
        this.$root.$on('loadInnerChatFinish', this.loadToParrentMessage)
        this.$emit('loadPage')
      }
    },
    handleScroll: debounce(async function () {
      const that = this
      this.$_checkMessageInViewPortAndChangeView(this.value.messages, this.mode).then(() => {
        if (this.value.messages?.length < this.value.messagesCount) {
          const blocks = document.getElementsByClassName('inner-chat-card')

          let lastKey = null
          Array.prototype.forEach.call(blocks, function(element) {
            if (that.$_isScrolledIntoView(element)) {
              lastKey = parseInt(element.getAttribute('index'))
            }
          })
          if (lastKey + 2 >= this.value.messages?.length) {
            this.$emit('loadPage')
          }
        }
      })
    }, 250),
    scrollSubs() {
      if (this.element) {
        this.element.addEventListener('scroll', this.handleScroll, false)
      }
    },
    scrollUnSubs() {
      if (this.element) {
        this.element.removeEventListener('scroll', this.handleScroll, false)
      }
    },
  },
  async mounted() {
    if (!this.value?.messages?.length) {
      this.$emit('loadPage')
    }
    this.element = document.getElementsByClassName('inner-chat-items')[0]
    this.scrollSubs()
    this.$_checkMessageInViewPortAndChangeView(this.value.messages, this.mode)
  },
  components: {
    EmptyTab,
    InnerChatCard,
  }
}
</script>
<style>
.blink {
  animation: blink 1s linear 1;
}
@keyframes blink {
	0% {
		transform: scale(1);
	}
	70% {
		transform: scale(1.05);
	}
	100% {
		transform: scale(1);
	}
}
</style>
<style scoped lang="scss">
.block-load-message {
  min-height: 34px;
  width: 100%;
  display: flex;
  justify-content: center;
  &.small {
    margin-top: 10px;
    border-top: 1px solid var(--color-main-green);
  }
  &.modal {
    border-bottom: 1px solid var(--color-main-green);
  }
}
.inner-chat-items {
  display: flex;
  height: 100%;
  overflow: auto;
  flex-wrap: wrap;
  &.small {
    flex-wrap: wrap;
  }
  &.desc {
    flex-wrap: nowrap;
    flex-direction: column-reverse;
    /* &::v-deep .history-items {
      padding: 0px !important;
    } */
  }
}
</style>
